import { useEffect } from 'react';

/**
 * Injects a JSON-LD <script> tag for the given schema object.
 * Cleans itself up on unmount or when the schema changes.
 *
 * Use a stable `id` per schema-on-page so multiple schemas can coexist
 * (Organization + Website + Breadcrumb on the same page is normal).
 */
export default function JsonLd({ id, data }) {
  useEffect(() => {
    if (!data) return;
    const scriptId = `jsonld-${id}`;
    let el = document.getElementById(scriptId);
    if (!el) {
      el = document.createElement('script');
      el.type = 'application/ld+json';
      el.id = scriptId;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const existing = document.getElementById(scriptId);
      if (existing) existing.remove();
    };
  }, [id, data]);
  return null;
}
